export class BlacklistCsvDTO{
    constructor(
        public login?: string,
        public eleicaoId?: number,
    ){}
}
